import { render, staticRenderFns } from "./Comp13t3.vue?vue&type=template&id=d95fab6a&scoped=true&"
import script from "./Comp13t3.vue?vue&type=script&lang=js&"
export * from "./Comp13t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp13t3.vue?vue&type=style&index=0&id=d95fab6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95fab6a",
  null
  
)

export default component.exports